export const ActionTypes = {
    LOAD_TOURS: "LOAD_TOURS",
    SELECTED_SPACE: "SELECTED_SPACE"
}